class WishlistManager {
  constructor() {
    document.addEventListener('DOMContentLoaded', () => {
      this.updateWishlistCount();
      this.initTextWishlistButtons();
      this.initIconWishlistButtons();
    });
  }

  // Utility: Get wishlist from localStorage
  getWishlist() {
    return JSON.parse(localStorage.getItem('wishlist')) || [];
  }

  // Utility: Save wishlist to localStorage
  saveWishlist(wishlist) {
    localStorage.setItem('wishlist', JSON.stringify(wishlist));
  }

  // Update wishlist count in multiple locations
  updateWishlistCount() {
    const wishlist = this.getWishlist();
    const countSelectors = ['#wt-count', '#wt-count-mobile']; // Add more selectors as needed

    countSelectors.forEach((selector) => {
      const element = document.querySelector(selector);
      if (element) {
        element.textContent = wishlist.length;
      }
    });
  }

  // Update icon state for .wt-button (filled or blank heart)
  updateHeartIcon(button, isInWishlist) {
    const blankHeart = button.querySelector('.wishlist-heart-blank');
    const fillHeart = button.querySelector('.wishlist-heart-fill');

    if (blankHeart && fillHeart) {
      blankHeart.style.display = isInWishlist ? 'none' : 'inline-block';
      fillHeart.style.display = isInWishlist ? 'inline-block' : 'none';
    }
  }

  // Initialize .wishlist-button (text-based)
    initTextWishlistButtons() {
    const wishlist = this.getWishlist();
  
    document.querySelectorAll('.wishlist-button').forEach((button) => {
      const handle = button.dataset.handle;
      const isInWishlist = wishlist.includes(handle);
  
      const addEl = button.querySelector('.wishlist-add');
      const addedEl = button.querySelector('.wishlist-added');
  
      // Set initial visibility state
      if (addEl) addEl.style.display = isInWishlist ? 'none' : 'inline-block';
      if (addedEl) addedEl.style.display = isInWishlist ? 'inline-block' : 'none';
      
      this.updateHeartIcon(button, isInWishlist);
      button.dataset.inWishlist = isInWishlist ? 'true' : 'false';
  
      // Add click listener
      button.addEventListener('click', () => {
        let wishlist = this.getWishlist();
        const handle = button.dataset.handle;
        const inWishlist = button.dataset.inWishlist === 'true';
  
        if (!inWishlist) {
          wishlist.push(handle);
          if (addEl) addEl.style.display = 'none';
          if (addedEl) addedEl.style.display = 'inline-block';
          button.dataset.inWishlist = 'true';
          this.updateHeartIcon(button, true);
        } else {
          wishlist = wishlist.filter(item => item !== handle);
          if (addEl) addEl.style.display = 'inline-block';
          if (addedEl) addedEl.style.display = 'none';
          button.dataset.inWishlist = 'false';
          this.updateHeartIcon(button, false);
        }
  
        this.saveWishlist(wishlist);
        this.updateWishlistCount();
      });
    });
  }

  // Initialize .wt-button (icon-based product card)
  initIconWishlistButtons() {
    const wishlist = this.getWishlist();

    document.querySelectorAll('.wt-button').forEach((button) => {
      const handle = button.dataset.productHandle;
      const isInWishlist = wishlist.includes(handle);

      this.updateHeartIcon(button, isInWishlist);

      button.addEventListener('click', () => {
        let wishlist = this.getWishlist();
        const inWishlist = wishlist.includes(handle);

        if (inWishlist) {
          wishlist = wishlist.filter(item => item !== handle);
        } else {
          wishlist.push(handle);
        }

        this.saveWishlist(wishlist);
        this.updateHeartIcon(button, !inWishlist);
        this.updateWishlistCount();
      });
    });
  }
}

// Instantiate the manager
new WishlistManager();
